import { number } from "echarts";

const watermark: any = {};
watermark.timer = {};
const setWatermark = (domId, str, type) => {
  const id = "watermark";
  const fatherBox: any = document.getElementById(domId);

  if (fatherBox && fatherBox.getElementsByClassName("watermarkBg")[0]) {
    // document.getElementsByClassName("watermarkBg")[0].remove();
    fatherBox.getElementsByClassName("watermarkBg")[0].remove();
    // (document.getElementById(id) as any).remove();
  }
  //创建一个画布
  const can: any = document.createElement("canvas");
  //设置画布的长宽
  // can.width = 440;
  // can.height = 120;
  can.width = fatherBox.clientWidth;
  can.height = fatherBox.clientHeight;
  const cans = can.getContext("2d");
  //旋转角度
  cans.rotate(-0.1);
  cans.font = type ? "0.32rem" : "14px";
  //设置填充绘画的颜色、渐变或者模式
  cans.fillStyle = "rgba(200, 200, 200, 0.40)";
  //设置文本内容的当前对齐方式
  //设置在绘制文本时使用的当前文本基线
  cans.textBaseline = "Middle";
  //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
  // const parW: number = can.width;
  // const num = Math.floor(can.width / 440);
  // cans.fillText(str, can.width / 9, can.height / 2);
  let isPro = false;
  let jh = 0;
  let iw = 0;
  if (type || fatherBox.clientWidth < 750) {
    iw = isPro ? can.width * 0.193 : can.width * 0.054;
    for (let i = iw; i < can.width; i += can.width * 0.6) {
      isPro = !isPro;
      jh = isPro ? can.height * 0.267 : can.height * 0.108;
      for (let j = jh; j < can.height * 2; j += can.height * 0.4) {
        // 填充文字，x 间距, y 间距
        cans.fillText(str, i, j);
      }
    }
  } else {
    iw = isPro ? 371 : 105;
    for (let i = iw; i < can.width; i += 400) {
      isPro = !isPro;
      jh = isPro ? 289 : 117;
      for (let j = jh; j < can.height * 2; j += 322) {
        // 填充文字，x 间距, y 间距
        cans.fillText(str, i, j);
      }
    }
  }

  const div = document.createElement("div");
  div.className = "watermarkBg";
  div.id = id;
  div.style.pointerEvents = "none";
  //   div.style.top = "10px";
  //   div.style.left = "0";
  //   div.style.position = "fixed";
  div.style.zIndex = "200";
  fatherBox.style.position = "relative";
  fatherBox.style.overflow = "hidden";
  // DOM方法获取视口尺寸
  div.style.width = fatherBox.clientWidth + "px";
  div.style.height = fatherBox.clientHeight + "px";
  div.style.position = "absolute";
  div.style.top = "0";
  div.style.left = "0";
  div.style.background =
    "url(" + can.toDataURL("image/png") + ") left top repeat";
  fatherBox.appendChild(div);
  // 无缝循环滚动
  const div1 = document.createElement("div");
  div1.className = "watermarkBg";
  div1.id = id + "1";
  div1.style.pointerEvents = "none";
  div1.style.zIndex = "200";

  div1.style.width = fatherBox.clientWidth + "px";
  div1.style.height = fatherBox.clientHeight + "px";
  div1.style.position = "absolute";
  div1.style.top = "0";
  div1.style.left = fatherBox.clientWidth;
  div1.style.background =
    "url(" + can.toDataURL("image/png") + ") left top repeat";
  // fatherBox.appendChild(div1);
  // let x = 0;
  // const moveRight = () => {
  //   //还可以考虑增加left的值判断，超出可视区域，进行left值的重置
  //   div.style.left = x + "px";
  //   div1.style.left = x + fatherBox.clientWidth + "px";
  //   x--;
  //   if (x + fatherBox.clientWidth == 0) {
  //     x = 0;
  //   }
  //   setTimeout(moveRight, 50); // 每50毫秒调用执行moveRight一次
  // };
  // moveRight();
  return id;
};

// 该方法只允许调用一次
watermark.set = (domId, str, type) => {
  clearInterval(watermark.timer[domId]);

  let id: any = setWatermark(domId, str, type);
  let w = 0;
  watermark.timer[domId] = setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWatermark(domId, str, type);
    }
    const nw = (document.getElementById(domId) as any).clientWidth;
    if (domId == "canvas-box" && watermark.timer["my-video"]) {
      // debugger;
      // const fatherBox: any = document.getElementById(domId);
      // fatherBox.getElementsByClassName("watermarkBg")[0].remove();
      return;
    }
    if (w > 0 && w != nw) {
      id = setWatermark(domId, str, type);
    }
    w = nw;
  }, 500);
  // onresize 事件通过监听对象的高和宽，其中任何一个属性发生变化都会触发 onresize 事件
  window.onresize = () => {
    setWatermark(domId, str, type);
  };
};
watermark.clear = domId => {
  if (domId) {
    clearInterval(watermark.timer[domId]);
    watermark.timer[domId] = null;
    const fatherBox: any = document.getElementById(domId);
    if (fatherBox && fatherBox.getElementsByClassName("watermarkBg")) {
      fatherBox.getElementsByClassName("watermarkBg")[0].remove();
    }
  } else {
    for (const k in watermark.timer) {
      clearInterval(watermark.timer[k]);
    }
    watermark.timer = {};
    const element = document.querySelectorAll(".watermarkBg");
    Array.prototype.forEach.call(element, function(node) {
      node.parentNode.removeChild(node);
    });
  }
};
export default watermark;
